import { motion, useMotionValue, useTransform, animate } from 'framer-motion';
import { useEffect } from 'react';
import logo from '../../../assets/logo.jpeg';
import './Preloader.css';

export function Preloader() {
  const count = useMotionValue(0);
  const display = useTransform(count, (v) => Math.floor(v));

  useEffect(() => {
    const controls = animate(count, 100, { duration: 1.0, ease: [0.16, 1, 0.3, 1] });
    return controls.stop;
  }, [count]);

  return (
    <motion.div
      className="loader"
      initial={{ opacity: 1 }}
      exit={{
        opacity: 0,
        y: -30,
        transition: { duration: 0.4, ease: [0.16, 1, 0.3, 1] },
      }}
    >
      {/* Subtle radial glow */}
      <div className="loader__orb" />

      <div className="loader__content">
        {/* Animated Ring & Logo */}
        <div className="loader__logo-container">
          <motion.svg
            className="loader__ring"
            viewBox="0 0 100 100"
            animate={{ rotate: 360 }}
            transition={{ duration: 3, repeat: Infinity, ease: 'linear' }}
          >
            <circle
              cx="50"
              cy="50"
              r="46"
              fill="none"
              stroke="rgba(255, 31, 58, 0.15)"
              strokeWidth="2"
            />
            <motion.circle
              cx="50"
              cy="50"
              r="46"
              fill="none"
              stroke="#ff1f3a"
              strokeWidth="2"
              strokeDasharray="280"
              initial={{ strokeDashoffset: 280 }}
              animate={{ strokeDashoffset: 0 }}
              transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
            />
          </motion.svg>
          <motion.img
            src={logo}
            alt="Luminar Logo"
            className="loader__logo"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, ease: 'easeOut' }}
          />
        </div>

        {/* Brand Name */}
        <motion.h1
          className="loader__title"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.6 }}
        >
          LUMINAR
        </motion.h1>

        {/* Tagline */}
        <motion.p
          className="loader__tagline"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.5 }}
        >
          Entertainment &amp; Events
        </motion.p>

        {/* Loading Progress */}
        <div className="loader__progress-wrap">
          <div className="loader__progress-bar">
            <motion.div
              className="loader__progress-fill"
              initial={{ width: '0%' }}
              animate={{ width: '100%' }}
              transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
            />
          </div>
          <div className="loader__percentage">
            <motion.span>{display}</motion.span>%
          </div>
        </div>
      </div>
    </motion.div>
  );
}
